<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="140px">
            <el-form-item label="设备编号：" prop="code">
                <el-input v-model="model.code"></el-input>
            </el-form-item>
            <el-form-item label="名称：" prop="name">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item label="简称：" prop="alias">
                <el-input v-model="model.alias"></el-input>
            </el-form-item>
            <el-form-item label="型号：" prop="model">
                <el-input v-model="model.model"></el-input>
            </el-form-item>
            <el-form-item label="生产厂家：" prop="company_produce">
                <el-select v-model="model.company_produce" placeholder="请选择" clearable filterable style="width: 100%">
                    <el-option v-for="item in producerList" :key="item.id"  :label="item.name" :value="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="使用单位：" prop="company_use">
                <el-input v-model="model.company_use"></el-input>
            </el-form-item>
            <el-form-item label="所在位置：" prop="location">
                <el-input v-model="model.location"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" :rows="4" v-model="model.remark"></el-input>
            </el-form-item>
            <el-form-item label="顺序：" prop="order_index">
                <el-input v-model.number="model.order_index"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { getAllProducerList } from '@/api/deviceuser'

export default {
    name: 'deviceWorkEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                check_id: '',
                check_code: '',
                check_name: '',
                code: '',
                name: '',
                alias: '',
                model: '',
                company_produce: '',
                company_use: '',
                remark: '',
                order_index: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: ''
            },
            getObj:{
                url:'/api/admin/devicework/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                code: [
                    {required: true, message: '设备编号不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                name: [
                    {required: true, message: '名称不能为空', trigger: 'blur'}
                ],
                alias: [
                    {required: true, message: '简称不能为空', trigger: 'blur'}
                ],
                model: [
                    {required: true, message: '型号不能为空', trigger: 'blur'}
                ],
                company_produce: [
                    {required: true, message: '生产厂家不能为空', trigger: 'blur'}
                ],
                company_use: [
                    {required: true, message: '使用单位不能为空', trigger: 'blur'}
                ],                
                order_index: [
                    {required: true, message: '顺序不能为空', trigger: 'blur'},
                    {type: 'number', message: '顺序必须是数字值', trigger: 'blur'}
                ],
            },
            checkObj:{
                url:'/api/admin/devicework/check',
                data:{}
            },
            exits_p_name:'code',
            exits_p_title:'设备编号',
            producerList: [],
        };
    },
    methods: {
        loadOtherData() {
            getAllProducerList().then(res=>{
                if(res.code ==1){
                    this.producerList = res.data
                }
            })
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/devicework/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        checkDeviceChange(obj){
            if(this.$isNull(obj)){
                this.model.check_code = ''
                this.model.check_name = ''
            }else{
                this.model.check_code = obj.code
                this.model.check_name = obj.name
            }
        },
    }
};
</script>